export default __webpack_public_path__ + "static/og-db5586812a70f9ad42d7b3cae1f67163.png";